import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FunctionComponent } from 'react';
import ReactDatePicker from 'react-datepicker';
import InputMask from 'react-input-mask';
import { useDispatch } from 'react-redux';
import { updateTaskSimple } from '../../../../../../../app/page/page-storage/tasks-simple/tasks-simple.actions';
import { taskSimpleSelectors } from '../../../../../../../app/resource/task-simple/task-simple.selectors';
import { ITaskSimple } from '../../../../../../../app/resource/task-simple/task-simple.types';
import { useSelectWithParams } from '../../../../../../../utils/selector.utils';

import { IDueDateProps } from './types';

export const DueDate: FunctionComponent<IDueDateProps> = ({ taskId }) => {
  const task = useSelectWithParams(taskSimpleSelectors.selectResourceById, taskId ?? '') as ITaskSimple;
  const dispatch = useDispatch();

  const defaultStartDateValue = task?.dueDate;
  const defaultDueDate = useMemo(() => {
    try {
      if (defaultStartDateValue) {
        const dateString = moment(defaultStartDateValue).format('YYYY-MM-DD');
        if (dateString === 'Invalid date') {
          return '0000-00-00 00:00:00';
        }
        return defaultStartDateValue;
      }
    } catch (error) {
      console.log(error);
      return '0000-00-00 00:00:00';
    }
  }, [defaultStartDateValue]);

  const [startDate, setStartDate] = useState(defaultDueDate ? moment(defaultDueDate).toDate() : undefined);

  useEffect(() => {
    if (defaultDueDate) {
      setStartDate(moment(defaultDueDate).toDate());
    }
  }, [defaultDueDate, defaultStartDateValue, task]);

  /**
   * @todo: If it is only needed to update the due date, it not necessary to send al the other data.
   * Create specific type to only update what it is needed instead of generic ITaskSimpleUpdate
   */
  const handleDateSelect = useCallback(
    (date: Date | undefined) => {
      if (date) {
        dispatch(
          updateTaskSimple(task.id, {
            dueDate: moment(date).format('YYYY-MM-DD'),
          }),
        );
      }
    },
    [dispatch, task],
  );
  return (
    <div className="col-4">
      <div className="field-container datepicker">
        <h5 className="bold mb-1">DUE DATE</h5>
        <div className="tags-container">
          {String(startDate) === 'Invalid Date' ? (
            <ReactDatePicker
              autoComplete="off"
              className="small-input"
              onChange={(date: Date) => setStartDate(date)}
              onSelect={(date: Date) => handleDateSelect(date)}
              onClickOutside={() => handleDateSelect(startDate)}
              dateFormat={'MM/dd/yyyy'}
              customInput={<InputMask mask="99/99/9999" placeholder="MM/dd/yyyy" />}
            />
          ) : (
            <ReactDatePicker
              className="small-input"
              selected={startDate}
              onChange={(date: Date) => setStartDate(date)}
              onSelect={(date: Date) => handleDateSelect(date)}
              onClickOutside={() => handleDateSelect(startDate)}
              dateFormat={'MM/dd/yyyy'}
              customInput={<InputMask mask="99/99/9999" placeholder="MM/dd/yyyy" />}
            />
          )}
        </div>
      </div>
    </div>
  );
};
